// extracted by mini-css-extract-plugin
export default {"errorMessage":"MyDatePicker_errorMessage__NEI0q"};